import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { LastManStandingPobjednici } from './LastManStandingPobjednici.jsx'
import { FiksanaTrakaDoljeInfo } from '../Layout/FiksanaTrakaDoljeInfo.jsx'

import { MaratonTimer } from './MaratonTimer.jsx'
import { MaratonProgress } from './MaratonProgress.jsx'


export class LastManStanding extends React.Component {


    constructor(props) {
        super(props);
        this.state = { maraton: null, nagradaLastManStanding: 10000, loading: true, obavijestTrakaVidljiva: false };

        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);

        this.renderLine1 = this.renderLine1.bind(this);
        this.renderLine2 = this.renderLine2.bind(this);
        this.renderLine3 = this.renderLine3.bind(this);

        this.sakrijObavijest = this.sakrijObavijest.bind(this);

        this.fetchData();
    }

    fetchData() {

        var nadimak = null;
        if (this.props.userChecked && this.props.user)
            nadimak = this.props.user.nadimak;

        var promises = Promise.all([casino.repos.casinoMaratonHappyHourRepo.get(false, nadimak, true)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    componentWillUnmount() {
        clearTimeout(this.timeouter);
        if (this.dataPromises)
            this.dataPromises.cancel();
    }

    setData(data) {
        var [maraton] = data;

        this.setState({
            maraton: maraton,
            loading: false
        });

        //kad prikazati traku, ako je utrka aktivna, ako je nije vidiio u zadnjih 1 min i ako nije kliknuo stop, i ako je prvih pol sata
        var firstHalf = new Date().getMinutes() <= 25;
        var zadnjuVidio = new Date(parseInt(localStorage.getItem("HHObavjestVidio") || 0));
        var zadnjuVidioDiff = (new Date() - zadnjuVidio);

        this.setState({
            obavijestTrakaVidljiva: firstHalf && zadnjuVidioDiff > 31 * 60 * 1000 && maraton.aktivnaUtrka
        });

        // idemo f krug
        var timeoutOut = 5000;
        if (maraton.sljedecaUtrkaStartMiliSecond > 0 && maraton.sljedecaUtrkaStartMiliSecond < 24 * 60 * 60 * 1000)
            timeoutOut = maraton.sljedecaUtrkaStartMiliSecond;
        if (maraton.sljedecaUtrkaStartMiliSecond > 0 && maraton.sljedecaUtrkaStartMiliSecond > 24 * 60 * 60 * 1000)
            timeoutOut = 24 * 60 * 60 * 1000;

        this.timeouter = setTimeout(() => {
            this.fetchData();
        }, timeoutOut);

    }

    sakrijObavijest() {

        localStorage.setItem("HHObavjestVidio", new Date().getTime());
        this.setState({ obavijestTrakaVidljiva: false });
    }


    render() {
        if (this.state.maraton && !this.state.maraton.lastManStandingAktivno)
            return <LastManStandingPobjednici
                pobjednici={this.state.maraton.lastManStandingRezultati.dobitniciRatova}
                showLoadingFn={this.props.showLoadingFn} />

        if (!this.state.maraton || !this.state.maraton.aktivno || !this.state.maraton.lastManStandingAktivno)
            return null

        var firstHalf = true;
        if (new Date().getMinutes() >= 30)
            firstHalf = false;
        let aktivnaUtrka = this.state.maraton.aktivnaUtrka;
        let sljedecaUtrka = new Date(this.state.maraton.sljedecaUtrka);

        return <div className={"maraton maximum margin-center  " + this.props.extraClass} >
            {this.props.hideHeader && <hr className="margin-bottom"></hr>}
            {!this.props.hideHeader && <NavLink to='/promotions'>
                <div id="game-tabs" className="relative maximum no-buttons"><div className="maximum"><ul><li><span>HAPPY HOUR MARATON</span></li></ul>
                    <div className="goto-maraton-container">
                        <div className="goto-maraton"></div>
                    </div>
                </div></div>
            </NavLink>}
            <div id="game-tabs" className="relative maximum no-buttons lines"><div className="maximum"><ul><li>
                <div>
                    {this.renderLine1(firstHalf, aktivnaUtrka, sljedecaUtrka)}
                    <hr className="sep" style={{ display: 'none' }}></hr>
                    {this.renderLine2()}
                    <hr className="sep"></hr>
                    {this.renderLine3()}
                </div>
            </li></ul></div></div>
            <hr className="tablet-hidden"></hr>
            {this.props.hideHeader && <hr></hr>}

            <LastManStandingPobjednici
                user={this.props.user}
                pobjednici={this.state.maraton.lastManStandingRezultati.dobitniciRatova}
                ratniciUBorbi={this.state.maraton.lastManStandingRezultati.ratniciUBorbi}
                showLoadingFn={this.props.showLoadingFn} />

            <FiksanaTrakaDoljeInfo popUpCode="poceoHapyHour" sakrijObavijest={this.sakrijObavijest}
                activeHH={this.state.obavijestTrakaVidljiva}></FiksanaTrakaDoljeInfo>

        </div>
    }

    renderLine1(firstHalf, aktivnaUtrka, sljedecaUtrka) {

        var trenutniPobjednik = this.state.maraton.trenutniPobjednik;

        var now = new Date();
        var toDate = new Date(now.getFullYear(), now.getMonth(), now.getDay(), now.getHours(), 30, 0);
        var diff = new Date(toDate - now);
        var display = diff.getMinutes() + 1;

        var nextDate = new Date(now.getFullYear(), now.getMonth(), now.getDay(), now.getHours(), 0, 0);
        nextDate.setTime(nextDate.getTime() + 60 * 60 * 1000);


        if (!aktivnaUtrka)
            return <div className={"line timer not-started"}>
                <div key="first-not-started" >
                    <div className="maraton-pocinje center-verticaly">
                        <span>
                            {casino.utils.dateToShortDateString(sljedecaUtrka)}.
                        </span>
                        <span>
                            {casino.utils.dateToTimeString(sljedecaUtrka)}
                        </span>
                    </div>
                    <div className="center-verticaly content" >
                        "Borba" počinje <b>{this.state.maraton.sljedeciKreceU}</b>. Budi spreman i ne propusti!
                    </div>
                </div>
            </div>

        let igracJeKvalificiran = this.state.maraton && this.state.maraton.trenutniIgracSpinova > 0 && this.state.maraton.trenutniIgracSpinova >= this.state.maraton.potrebnoSpinova ? true : false;
        if (aktivnaUtrka)
            return <div className={"line timer firstHalf " + (igracJeKvalificiran || (!firstHalf && !trenutniPobjednik) ? ' imamoPobjednika' : ' nemamoPobjednika')}>

                {firstHalf && !igracJeKvalificiran && <div key="first">
                    <MaratonTimer key='i1'></MaratonTimer>
                    <div className="center-verticaly content" >
                        Još <b>{display} minuta</b> za kvalifikaciju.
                    {this.state.maraton.trenutniIgracSpinova == 0 && ' Zaigraj i postani ratnik!'}
                        {this.state.maraton.trenutniIgracSpinova > 0 && this.state.maraton.trenutniIgracSpinova < this.state.maraton.potrebnoSpinova && ' Potrebno je još samo malo da bi postao ratnik.'}
                        {this.state.maraton.trenutniIgracSpinova > 0 && this.state.maraton.trenutniIgracSpinova >= this.state.maraton.potrebnoSpinova && [' Dok čekaš da počne treniraj igranjem naše ponude.']}
                    </div>
                </div>}

                {igracJeKvalificiran || (!firstHalf && !trenutniPobjednik) ? <div key="third">
                    <MaratonProgress key='p2' progress={-1} color="#a5cf84"></MaratonProgress>
                    <div className="center-verticaly content" >
                        <b>Borba je završena!</b> Čestitamo preživjelima
                    </div>
                </div> : ''}

            </div>
    }

    renderLine2() {
        let brojPreostalihRatnika = this.state && this.state.maraton && this.state.maraton.lastManStandingRezultati && this.state.maraton.lastManStandingRezultati.ratniciUBorbi ? this.state.maraton.lastManStandingRezultati.ratniciUBorbi.length : 0;
        return <div className="line igraci" key="secondHalf">
            <div className="center-verticaly content" >
                {brojPreostalihRatnika > 0 ? <div>Broj preostalih ratnika: <b className="color-red">{brojPreostalihRatnika}</b></div> : 'Igraj i postani ratnik u prvoj polovici sata.'}
            </div>
        </div>
    }

    renderLine3() {
        let trenutniDobitak = this.state.maraton && this.state.maraton.lastManStandingRezultati && this.state.maraton.lastManStandingRezultati.ratniciUBorbi
            && this.state.maraton.lastManStandingRezultati.ratniciUBorbi.length > 0 ? this.state.nagradaLastManStanding / this.state.maraton.lastManStandingRezultati.ratniciUBorbi.length : this.state.nagradaLastManStanding;

        return <div className="line dobitnik" key="thirdHalf">
            <div className="center-verticaly content">
                Trenutni iznos dobitka: <b className="color-red">{casino.utils.numberToLocaleString(trenutniDobitak)}</b>
            </div>
        </div>
    }
};
